// Cross-tab logout propagation.
//
// Сценарий: пользователь работает в двух вкладках. В вкладке A нажимает «Выход»
// → useLogoutMutation пишет timestamp в `multitool:auth_signal`. Вкладка B ловит
// storage-event, чистит свой react-query кэш и перенаправляет на /login. Без этого
// вкладка B продолжала бы показывать данные ушедшего пользователя до первого
// HTTP-запроса (когда backend вернёт 401).
//
// Защищает от security-инцидента «на shared workstation следующий юзер видит
// данные предыдущего во второй вкладке».
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { AUTH_SIGNAL_KEY } from "@/api/constants";
import { resetClientState } from "./useAuth";

export function useCrossTabLogout(): void {
  const qc = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event: StorageEvent) => {
      if (event.key !== AUTH_SIGNAL_KEY) return;
      // Кто-то в другой вкладке вызвал emitAuthSignal — синхронизируемся.
      resetClientState(qc);
      // Только если ещё не на /login (избегаем циклов навигации).
      if (!window.location.pathname.startsWith("/login")) {
        navigate("/login", { replace: true });
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, [qc, navigate]);
}
